const MapActionsCliente = {
    NOME_MODULO: "cliente",
    SALVAR_CLIENTE_ATUAL: "salvarClienteAtual",
};

const MapActionsModuleCliente = {
    SALVAR_CLIENTE_ATUAL: MapActionsCliente.NOME_MODULO + "/" + MapActionsCliente.SALVAR_CLIENTE_ATUAL
}

Object.freeze(MapActionsCliente);
Object.freeze(MapActionsModuleCliente);

export {MapActionsCliente, MapActionsModuleCliente};
